import { hdrm, view } from '@yola/ws-sdk';
import {
  applyHiddenClassTokens,
  getHiddenClassTokens,
  stripHiddenClassTokens,
} from './hidden-class-tokens';

const { updateStrategies } = hdrm.constants;
const LIVE_STRATEGY_OPTIONS = {
  strategy: updateStrategies.UPDATE_LIVE_ONLY,
  skipDesignAutomation: true,
};

const getCurrentClass = (elementId) => view.accessors.getElementAttribute(elementId, 'class') || '';

export const temporarilyRevealBlock = (elementId) => {
  const currentClass = getCurrentClass(elementId);
  const hiddenClassTokens = getHiddenClassTokens(currentClass);

  if (!hiddenClassTokens.length) return null;

  const nextClass = stripHiddenClassTokens(currentClass);

  view.operations.setElementAttribute(elementId, 'class', nextClass, LIVE_STRATEGY_OPTIONS);

  return hiddenClassTokens;
};

export const restoreBlockHiddenState = (elementId, hiddenClassTokens) => {
  if (!hiddenClassTokens?.length) return;

  const currentClass = getCurrentClass(elementId);
  const nextClass = applyHiddenClassTokens(currentClass, hiddenClassTokens);

  view.operations.setElementAttribute(elementId, 'class', nextClass, LIVE_STRATEGY_OPTIONS);
};
